module.exports = __webpack_public_path__ + "static/media/mailIcon.0a31086b.svg";